import { Component, HostListener, AfterViewInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { openCloseAnimation } from 'src/assets/animations/openCloseAnImation';

@Component({
    selector: 'app-header-inferior',
    templateUrl: './header-inferior.component.html',
    animations: [openCloseAnimation]
})
export class HeaderInferiorComponent implements AfterViewInit {

    public active = false;

    public showLanguages = false;
    public selectedLanguage = '';

    @HostListener('window:resize', [])
    onResize() {
        this.updateLogoByScreenSize();
        if (!this.active) {
            document.body.style.overflow = 'scroll';
        }
    }

    constructor(
        private readonly _translateService: TranslateService
    ) { }

    ngOnInit(): void {
        this.onResize();
        if (window.navigator.language.includes('es')) {
            this.selectedLanguage = 'header-superior.idiomas.esp'
        } else {
            this.selectedLanguage = 'header-superior.idiomas.ingUSA'
        }

        this.active = false;
        document.body.style.overflow = 'scroll';
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.updateLogoByScreenSize());
    }

    public activeMenu() {
        if (window.innerWidth < 992) {
            this.active = !this.active;
            this.active ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'scroll';
        }
    }

    private updateLogoByScreenSize(): void {
        const img = document.getElementById('imgHeaderInf') as HTMLImageElement;
        img.src = 'assets/img/logos/Logos_GlobalIPCert_V3_2.png';
        if (window.innerWidth <= 575) {
            img.src = 'assets/img/logos/Favicon_GlobalIPCert.png';
            img.style.width = '2.5rem';
        } 
        else if (window.innerWidth >= 576 && window.innerWidth < 992) {
            img.src = 'assets/img/logos/Logos_GlobalIPCert_V3_2.png';
            img.style.width = '10rem';
        }
        else {
            img.src = 'assets/img/logos/Logos_GlobalIPCert_V3_2.png';
            img.style.width = '15rem';
        }
    }

    public changeLanguage(language: number) {
        if (language === 1) {
            this._translateService.use('es-ES');
            this._translateService.setDefaultLang('es-ES');
            this.selectedLanguage = 'header-superior.idiomas.esp';
            this.showLanguages = false;
        } else if (language === 2) {
            this._translateService.use('en-GB');
            this._translateService.setDefaultLang('en-GB');
            this.selectedLanguage = 'header-superior.idiomas.ingUK';
            this.showLanguages = false;
        } else if (language === 3) {
            this._translateService.use('en-US');
            this._translateService.setDefaultLang('en-US');
            this.selectedLanguage = 'header-superior.idiomas.ingUSA';
            this.showLanguages = false;
        }
    }
}